import * as actions from './albumActions'
import constant from '../../constant/appConst'

const albumInit = {}
export default (state = albumInit, action) => {
	switch (action.type) {
		case actions.GET_ALBUM_SUCCESS:
			if (action.album)
				return {
					id: action.album.id,
					label: action.album.label,
					title: action.album.title,
					image: action.album.image,
					hires: action.album.hires,
					artist: action.album.artist ? { id: action.album.artist.id, name: action.album.artist.name } : undefined,
					tracks_count: action.album.tracks_count,
					duration: action.album.duration,
					isQobuzissime: action.album.awards && action.album.awards.some(award => award.award_slug === 'qobuzissime'),
					description: action.album.description,
					genre: action.album.genre,
					release_date_original: action.album.release_date_original,
					maximum_bit_depth: action.album.maximum_bit_depth,
					maximum_channel_count: action.album.maximum_channel_count,
					maximum_sampling_rate: action.album.maximum_sampling_rate,
					maximum_technical_specifications: action.album.maximum_technical_specifications,
					orderUrl: action.album.articles && action.album.articles.length ? action.album.articles
						.sort((a, b) => (constant.trackQuality[b.type] || 0) - (constant.trackQuality[a.type] || 0))[0].url
						: ''
				}
			return albumInit
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/pages/album/albumReducers.js